import React, { useEffect, useMemo, useCallback } from 'react';
import { useRefCallback } from '@okee-uikit/react-hooks';
import { guid } from '@okee-uikit/react-utils';
import { useSelect } from '../../../hooks/select';
import { RcPopover } from '../../../units/popover-wrapper';
import { SelectPopoverPanel } from './SelectPopoverPanel';
import { SelectRimlessInput } from './SelectRimlessInput';
export function SelectRimlessPopper(props) {
  var useTag = props.useTag,
      _props$searchable = props.searchable,
      searchable = _props$searchable === void 0 ? false : _props$searchable,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'bottom-start' : _props$placement,
      placeholder = props.placeholder,
      onShow = props.onShow,
      onHide = props.onHide,
      show = props.show,
      clearable = props.clearable,
      popoverWidth = props.popoverWidth,
      children = props.children,
      alignType = props.alignType,
      width = props.width,
      emptyRender = props.emptyRender,
      emptyContent = props.emptyContent,
      renderTrigger = props.renderTrigger,
      popoverClassName = props.popoverClassName,
      onSearchChange = props.onSearchChange,
      popoverWrapperClassName = props.popoverWrapperClassName,
      searchPlaceholder = props.searchPlaceholder,
      boundariesDetectionDebounce = props.boundariesDetectionDebounce,
      getPopupContainer = props.getPopupContainer,
      renderFooter = props.renderFooter,
      onVisibleChange = props.onVisibleChange;
  var select = useSelect();
  var triggerId = useMemo(function () {
    return guid();
  }, []);
  var triggerIds = useMemo(function () {
    return [triggerId];
  }, []);
  var handleShow = useRefCallback(function () {
    onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange(true);
    onShow === null || onShow === void 0 ? void 0 : onShow();
  });
  var handleHide = useRefCallback(function () {
    onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange(false);
    onHide === null || onHide === void 0 ? void 0 : onHide();
  });
  var searchChange = useRefCallback(onSearchChange);
  var handleClear = useCallback(function (val) {
    if (!val) {
      select.resetValue();
    }
  }, []);
  useEffect(function () {
    var trySetState = function trySetState() {
      if (!select.multiple) {
        handleHide();
      }
    };

    select.addListener('try-set-state', trySetState);
    return function () {
      select.removeListener('try-set-state', trySetState);
    };
  }, []);

  var popoverPanel = function popoverPanel() {
    return React.createElement(SelectPopoverPanel, {
      show: show,
      autoAlign: false,
      popoverWidth: popoverWidth,
      triggerId: triggerId,
      searchable: searchable,
      emptyRender: emptyRender,
      emptyContent: emptyContent,
      onSearchChange: searchChange,
      searchPlaceholder: searchPlaceholder,
      renderFooter: renderFooter
    }, children);
  };

  return React.createElement(React.Fragment, null, React.createElement(SelectRimlessInput, {
    useTag: useTag,
    triggerId: triggerId,
    show: show,
    clearable: clearable,
    placeholder: placeholder,
    alignType: alignType,
    onValueChange: handleClear,
    width: width,
    renderTrigger: renderTrigger
  }), React.createElement(RcPopover, {
    wrapperClassName: popoverWrapperClassName,
    show: show,
    getPopper: popoverPanel,
    arrow: false,
    placement: placement,
    offset: {
      x: 0,
      y: 4
    },
    triggerIds: triggerIds,
    onShow: handleShow,
    onHide: handleHide,
    scaleAnimation: "y",
    lazyInit: false,
    className: popoverClassName,
    boundariesDetectionDebounce: boundariesDetectionDebounce,
    getPopupContainer: getPopupContainer,
    defaultToBody: true
  }));
}